var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.whitelabelHasRightsToArchiveCustomer ||
    _vm.webshipperStaffHasRightsToArchiveCustomer
  )?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',[_vm._v(_vm._s(_vm.$t("archive_customer")))]),_c('hr'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.infoMessage))])]),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.confirmModal(
                $event,
                _vm.$t('are_you_sure'),
                _vm.confirmModalMessage,
                _vm.archiveCustomer
              )}}},[_vm._v(" "+_vm._s(_vm.$t("archive"))+" ")]),_c('br'),(_vm.customer.archived_at)?_c('strong',[_vm._v(_vm._s(_vm.$t("customer_is_archived")))]):_vm._e()])])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }